/** Rough "useful text" measure used when comparing recognition candidates. */
export function textCoverage(text: string): number {
  return (text.match(/[\p{L}\p{N}]/gu) || []).length;
}

export function joinPages(pages: { pageNumber: number; text: string }[]): string {
  return pages
    .slice()
    .sort((a, b) => a.pageNumber - b.pageNumber)
    .map((p) => `--- Page ${p.pageNumber} ---\n${p.text}`.trimEnd())
    .join('\n\n');
}
